import React from "react";
import Layout from '../components/layout'
import { Link, graphql } from "gatsby"
import Helmet from 'react-helmet'
import Footer from '../components/Footer'

class BlogArchiveTemplate extends React.Component {
    render(){
      
      const data = this.props.data;

      return (
        <Layout pageType="blogArchive" location={this.props.location}>
          <Helmet title={`Journals | Creative Portrait Photographer | Clair Estelle`} /> 
          <main>
            <div className="blog-wrapper">
              {
                data.allBlog.edges.map(({node}) => {
                  
                  var leadImage = node.leadImageUrl ? <div><img src={node.leadImageUrl} alt={node.leadImageAltText} /></div> : "";
                  
                  return (
                    <div className="blog-content">
                      <div className="blog-left">                        
                        {leadImage}      
                        <div dangerouslySetInnerHTML={{ __html: node.content }} />
                        <p class="tags">
                        <ul>
                        {
                          node.tags.map( tag => {
                            return  <li><Link to={`/tags/${tag.slug}`}>{tag.title}</Link></li>;
                          })
                        }
                        </ul>

                        </p>
                      </div>
                      <div className="blog-right">
                        <Link to={`/blog/${node.slug}`}><h2>{node.title}</h2></Link>
                        <div dangerouslySetInnerHTML={{ __html: node.sideBarContent }} />
                      </div>
                    </div>
                  );
                })
              }
            </div>
            <div className="blog-footer">
              <Footer />
            </div>
          </main>
        </Layout>
      );
    }
    
  };

  export default BlogArchiveTemplate
  
  export const query = graphql`
    query($month: String!) {
      allBlog (filter: { publishedMonth:{ eq:$month }})
      {
        edges{
          node {
            title,
            slug,
            leadImageUrl,
            leadImageAltText,
            content,
            sideBarContent,
            tags {
              title,
              slug
            }
          }
        }
      }
    }
  `;